'use client';

import { c as _c } from "react/compiler-runtime";
import { useToast } from '@common/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AuthApi } from '@/api';
interface UsePutCommentMutationParams {
  /** 수정 대상 댓글 id */
  commentId: number;
  /** 성공 시 상위에서 모드 종료와 스크롤 복원을 처리 */
  onSuccess?: () => void;
}

// 댓글 수정 API와 목록 재조회 처리만 담당하는 얇은 mutation 훅이다.
export const usePutCommentMutation = t0 => {
  const $ = _c(12);
  const {
    commentId,
    onSuccess
  } = t0;
  const {
    toast,
    toastError
  } = useToast();
  const queryClient = useQueryClient();
  let t1;
  if ($[0] !== commentId) {
    t1 = contents => AuthApi["put:/wello/v2/auth/wello-comment/{welloCommentId}"]({
      path: {
        welloCommentId: commentId
      },
      body: {
        contents
      }
    });
    $[0] = commentId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onSuccess || $[3] !== queryClient || $[4] !== toast) {
    t2 = async () => {
      toast({
        type: "success",
        message: "\uB313\uAE00 \uC218\uC815\uC644\uB8CC"
      });
      await queryClient.invalidateQueries();
      onSuccess?.();
    };
    $[2] = onSuccess;
    $[3] = queryClient;
    $[4] = toast;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== toastError) {
    t3 = error => {
      toastError({
        error
      });
    };
    $[6] = toastError;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = {
      mutationFn: t1,
      onSuccess: t2,
      onError: t3
    };
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return useMutation(t4);
};